export default __webpack_public_path__ + "static/media/nemesysco.d319561d.svg";